import { Component, Input } from "@angular/core";

@Component({
	selector: "stages-buttons-bottom",
	templateUrl: "./buttons-bottom.component.html",
	styleUrls: ["buttons-bottom.component.scss"],
})
export class ButtonsBottomComponent {
	@Input()
	removeBoundaries: boolean = false;

	@Input()
	alignRight: boolean = true;

	@Input()
	isOnTop: boolean = false;

	@Input()
	addPadding: boolean = false;

	@Input()
	removeTopPadding: boolean = false;
}
